import React from 'react'
import fastFood from '../../assets/fastfood.svg'
import Footer from '../../components/Footer/Footer'
import styles from './Earnings.module.css'

const Earnings = () => {
    const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    return (
        <div className={styles.container}>
            <div className={styles.box}></div>
            <header>
                <h2>Earnings</h2>
                <h1>$ 178.20</h1>
            </header>

            <main>
                <p className={styles.status}>Recent Transaction</p>
                {
                    arr.map(item => (
                        <div className={styles.card}>
                            <img src={fastFood} alt="fast-food" />
                            <div className={styles.name}>
                                <h3>Food delivered</h3>
                                <small>Economy Delivery</small>
                            </div>
                            <div className={styles.deliveryStatus}>
                                <small>$ 8.50</small>
                                <h5>Paid via PayPal</h5>
                            </div>
                            <div className={styles.deliveryStatus}>
                                <small>$ 3.50</small>
                                <h5>Earned</h5>
                            </div>
                        </div>

                    ))
                }
            </main>
            <Footer />
        </div>
    )
}

export default Earnings
